import { useSelector } from 'react-redux'
import { IStore } from '../interfaces/Store'

const Step4AddressHook = (watchExistingAddress: string = '') => {
  const { address, status } = useSelector(
    (store: IStore) => store.addressReducer
  )
  const addressStatus = status
  const {
    folder: { top_heb, existing_address },
  } = useSelector((store: IStore) => store.folderReducer)

  let userAddress = ''
  if (address) {
    const { zipcode, city } = address
    userAddress = [address.address, zipcode, city].filter(Boolean).join(', ')
  }

  const topHebShowUpload =
    (watchExistingAddress === '1' || existing_address === '1') &&
    top_heb === '1'

  const showUpload =
    !address ||
    watchExistingAddress === '0' ||
    topHebShowUpload ||
    (watchExistingAddress === '' && existing_address === '0')

  return {
    address,
    addressStatus,
    existing_address,
    userAddress,
    showUpload,
    showUploadSelect: !topHebShowUpload,
  }
}

export default Step4AddressHook
